module.exports = __webpack_public_path__ + "img/fd689c2.jpg";